export default __webpack_public_path__ + "static/media/ensvee-logo.6b6fcb58.svg";